import React from 'react';
import { motion } from 'framer-motion';
import { HERO } from '../lib/data';
import { useLanguage } from '../lib/LanguageContext';
import { HOME_CONTENT } from '../lib/localizedContent';

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1], delay },
});

const Hero = () => {
  const { language } = useLanguage();
  const content = HOME_CONTENT[language];
  return (
    <section
      id="top"
      className="relative w-full h-[100svh] min-h-[640px] overflow-hidden bg-ink"
      data-testid="hero-section"
    >
      <motion.img
        src={HERO.image}
        alt={content.heroAlt}
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.2, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
      <div className="absolute inset-0 grain" />

      {/* Headline / wordmark */}
      <div className="absolute inset-0 flex items-center justify-center text-center">
        <div className="w-full px-6 md:px-12 lg:px-16 pt-20">
          <motion.h1
            {...fade(0.6)}
            className="mx-auto max-w-6xl font-sans font-extrabold text-bone leading-[1.05] tracking-normal text-4xl sm:text-6xl md:text-7xl lg:text-8xl"
            data-testid="hero-wordmark"
          >
            {content.heroTitle}
          </motion.h1>
          <motion.p {...fade(0.9)} className="mt-6 text-bone text-sm md:text-base font-bold">
            {content.location}
          </motion.p>
        </div>
      </div>

    </section>
  );
};

export default Hero;
